import { Radar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Radar,
  data() {
    return {
      options: {
        plugins: {
          datalabels: {
            color: "orange",
            display: "auto",
            align: "right",
            offset: 15
          }
        },
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          }
        },
        legend: {
          display: true,
          labels: {
            boxWidth: 0,
            fontStyle: "bold",
            fontColor: "#000000",
            fontSize: 14
          }
        },
        scale: {
          angleLines: {
            display: false
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.2)",
            lineWidth: 1
          },
          ticks: {
            suggestedMin: 1,
            suggestedMax: 5,
            fontSize: 14
          },
          pointLabels: {
            fontColor: "#000000",
            fontSize: 14,
            callback: label => {
              if (/\s/.test(label)) {
                return label.split(" ");
              } else {
                return label;
              }
            }
          }
        }
      }
    };
  },
  mixins: [reactiveProp],

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
